import React from 'react';
import PropTypes from 'prop-types';

import { CmsEntities } from 'client/data/models/cms';
import { HashAnchor } from 'site-modules/shared/components/hash-anchor/hash-anchor';
import { ResearchEntry } from 'site-modules/editorial/components/type/one-column/research-entry/research-entry';
import { SectionBackToTopBtn } from 'site-modules/editorial/components/section-back-to-top-btn/section-back-to-top-btn';
import { InlineSubnav } from 'site-modules/editorial/components/type/one-column/inline-subnav/inline-subnav';

import './article-anchor-section.scss';

export function ArticleAnchorSection({ entry, isMobile = false, entriesProps }) {
  const anchor = entry.metadata('anchor').value();
  const title = entry.metadata('title').value();
  const TitleTag = entry.metadata('titleTag').value('div');
  const entries = entry.children(entry.id);
  const subnav = entry.hasChild('subnav') ? entry.child('subnav') : null;

  return (
    <div className="article-anchor-section pos-r">
      {!!anchor && <HashAnchor name={anchor} className="anchor" />}
      {/* eslint-disable-next-line react-hooks/static-components -- TitleTag is a CMS-configured stable HTML tag string */}
      {!!title && <TitleTag className="mb-0_5">{title}</TitleTag>}
      {entries.map((child, index) => {
        const key = `${entry.id}-${child.id}-${index}`;
        return <ResearchEntry key={key} entry={child} isMobile={isMobile} entriesProps={entriesProps} />;
      })}
      {!!subnav && <InlineSubnav entry={subnav} />}
      <SectionBackToTopBtn styles={{ marginBottom: '20px' }} />
    </div>
  );
}

ArticleAnchorSection.propTypes = {
  entry: CmsEntities.Content.isRequired,
  entriesProps: PropTypes.shape({
    title: PropTypes.string,
    canonical: PropTypes.string,
    pathname: PropTypes.string,
  }).isRequired,
  isMobile: PropTypes.bool,
};
